import {
  UserAccount,
  GroupMemberProfile,
  GroupSettings,
  Venue,
  Match,
  MatchRSVP,
  MatchJoinRequest,
  PaymentRecord,
  MatchComment,
  Announcement,
  Poll,
  ActivityLog,
  NotificationSettings,
  PrivacySettings,
  WorldMatchFixture,
  FootballNewsItem
} from '../types';

export const INITIAL_USER: UserAccount = {
  id: 'usr_saif',
  email: 'saif@blankfc.com',
  fullName: 'Saif Ahmed',
  displayName: 'Saif',
  nickname: 'El Maestro',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=80',
  bio: 'Midfield dictator & turf controller. Right foot. Real Madrid & Messi fan.',
  dateOfBirth: '1998-05-14',
  phoneNumber: '+880 1712 345678',
  favoriteClub: 'Real Madrid',
  favoritePlayer: 'Messi',
  favoriteNationalTeam: 'Argentina',
  coverBannerUrl: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=1200&auto=format&fit=crop&q=80',
  themePreference: 'dark',
  reducedAnimations: false,
  compactMode: false,
  isVerified: true,
  verificationStatus: 'approved',
  createdAt: '2024-01-10T10:00:00Z',
};

export const INITIAL_GROUP: GroupSettings = {
  id: 'grp_gigaballs',
  name: 'GigaBalls FC',
  logoUrl: 'https://images.unsplash.com/photo-1518091043644-c1d4457512c6?w=200&auto=format&fit=crop&q=80',
  coverUrl: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200&auto=format&fit=crop&q=80',
  description: 'GigaBalls FC - Weekly Friday turf matches, friendly banter, and fair plays in Dhaka.',
  joinCode: 'GB2026',
  inviteLink: 'https://gigaballs.app/join/GB2026',
  currency: '৳',
  timezone: 'Asia/Dhaka',
  cardEditMode: 'admin_only',
  matchDefaults: {
    durationMinutes: 60,
    playerLimit: 14,
    minPlayers: 10,
    matchFormat: '7v7',
    rsvpDeadlineHoursBefore: 5,
    waitlistEnabled: true,
    guestPlayersEnabled: true,
  },
  teamSettings: {
    availablePositions: ['GK', 'CB', 'LB', 'RB', 'CDM', 'CM', 'CAM', 'LW', 'RW', 'ST'],
    defaultFormations: ['2-3-1', '1-2-1', '2-2-2', '3-2-1'],
    autoBalancingEnabled: true,
    playerRatingsEnabled: true,
    communityRatingsEnabled: true,
    defaultTeamColors: { teamA: '#10B981', teamB: '#3B82F6' },
  },
  finance: {
    defaultTurfCost: 2100,
    paymentMethods: ['bKash', 'Nagad', 'Cash', 'Wallet'],
    bkashNumber: '01712-345678',
    nagadNumber: '01812-987654',
    cashEnabled: true,
    walletSystemEnabled: true,
    paymentScreenshotEnabled: true,
  },
  statsEnabled: {
    goals: true,
    assists: true,
    playerRatings: true,
    cards: true,
    saves: true,
    cleanSheets: true,
    motm: true,
    attendance: true,
    winPct: true,
    funAwards: true,
  },
  communityEnabled: {
    matchComments: true,
    polls: true,
    reactions: true,
    mentions: true,
    playerVoting: true,
    announcements: true,
  },
  footballFeedEnabled: {
    worldFootballSection: true,
    liveScores: true,
    news: true,
    followSystem: true,
  }
};

export const INITIAL_MEMBERS: GroupMemberProfile[] = [
  {
    id: 'mem_saif',
    userId: 'usr_saif',
    groupId: 'grp_blank_fc',
    role: 'owner',
    displayName: 'Saif',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=80',
    isVerified: true,
    verificationStatus: 'approved',
    nickname: 'El Maestro',
    jerseyNumber: 8,
    primaryPosition: 'CM',
    secondaryPositions: ['CAM', 'RW'],
    preferredFoot: 'Right',
    unwantedPositions: ['GK', 'CB'],
    goalkeeperAbility: 'No',
    preferredTeamColor: 'Black',
    competitivePreference: 'Competitive',
    footballCard: {
      overall: 78,
      pace: 76,
      shooting: 72,
      passing: 84,
      dribbling: 80,
      defending: 71,
      physical: 73,
    },
    isActive: true,
    walletBalance: 0,
    stats: {
      matchesPlayed: 0,
      wins: 0,
      draws: 0,
      losses: 0,
      goals: 0,
      assists: 0,
      cleanSheets: 0,
      motmCount: 0,
      attendancePct: 100,
      winPct: 0,
      averageRating: 8.0,
      lateArrivals: 0,
      noShows: 0,
    }
  }
];

export const INITIAL_VENUES: Venue[] = [
  {
    id: 'ven_bashundhara',
    name: 'Bashundhara Sports Arena',
    address: 'Block N, Bashundhara R/A, Dhaka',
    googleMapsUrl: 'https://maps.google.com/?q=Bashundhara+Sports+Arena+Dhaka',
    latitude: 23.8103,
    longitude: 90.4125,
    phoneNumber: '+880 1819 001122',
    imageUrl: 'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=800&auto=format&fit=crop&q=80',
    turfSize: '7v7 Premium Synthetic Turf',
    pricePerHour: 2100,
    isIndoor: false,
    rating: 4.8,
    notes: 'Floodlights, changing rooms, mineral water provided. High quality rubber infill.',
    totalMatchesPlayed: 18,
  },
  {
    id: 'ven_dhanmondi',
    name: 'Dhanmondi Executive Turf',
    address: 'Road 27 (Old), Dhanmondi, Dhaka',
    googleMapsUrl: 'https://maps.google.com/?q=Dhanmondi+Turf+Dhaka',
    latitude: 23.7461,
    longitude: 90.3742,
    phoneNumber: '+880 1711 998877',
    imageUrl: 'https://images.unsplash.com/photo-1575361204480-aadea25e6e68?w=800&auto=format&fit=crop&q=80',
    turfSize: '6v6 Indoor Covered Turf',
    pricePerHour: 1800,
    isIndoor: true,
    rating: 4.5,
    notes: 'Covered roof, rainy day friendly, clean shower facilities.',
    totalMatchesPlayed: 6,
  },
  {
    id: 'ven_gulshan',
    name: 'Gulshan Arena Ground',
    address: 'Gulshan 2 Circle, Dhaka',
    googleMapsUrl: 'https://maps.google.com/?q=Gulshan+Arena+Ground+Dhaka',
    latitude: 23.7925,
    longitude: 90.4078,
    phoneNumber: '+880 1912 334455',
    imageUrl: 'https://images.unsplash.com/photo-1459865264687-595d652de67e?w=800&auto=format&fit=crop&q=80',
    turfSize: '8v8 FIFA Quality Field',
    pricePerHour: 2500,
    isIndoor: false,
    rating: 4.9,
    notes: 'Spacious 8v8 field, spectator seats, cafeteria on premise.',
    totalMatchesPlayed: 4,
  }
];

// Calculate upcoming Friday
const today = new Date();
const nextFriday = new Date(today);
nextFriday.setDate(today.getDate() + ((5 - today.getDay() + 7) % 7 || 7));
const upcomingFridayStr = nextFriday.toISOString().split('T')[0];

export const INITIAL_MATCHES: Match[] = [
  {
    id: 'mat_friday_clash',
    groupId: 'grp_blank_fc',
    title: 'Friday Night Turf Clash',
    date: upcomingFridayStr,
    startTime: '21:00',
    endTime: '22:00',
    durationMinutes: 60,
    matchType: '7v7',
    maxPlayers: 14,
    minPlayers: 10,
    venueId: 'ven_bashundhara',
    venueName: 'Bashundhara Sports Arena',
    venueAddress: 'Block N, Bashundhara R/A, Dhaka',
    venueMapUrl: 'https://maps.google.com/?q=Bashundhara+Sports+Arena+Dhaka',
    totalTurfFee: 2100,
    organizerContribution: 0,
    extraCost: 0,
    gkDiscount: 0,
    guestFee: 150,
    estimatedCostPerPlayer: 150,
    isCostFrozen: false,
    rsvpDeadline: `${upcomingFridayStr}T18:00:00Z`,
    visibility: 'private',
    joinPolicy: 'members_only',
    isDiscoverable: false,
    isOpenToGuests: true,
    isLocked: false,
    isCancelled: false,
    status: 'upcoming',
    rulesNote: 'Bring both Green and Blue jerseys! Be at the turf by 8:45 PM for warmups.',
    createdByMemberId: 'mem_saif',
    createdByName: 'Saif Ahmed',
    createdAt: new Date().toISOString(),

    teamA: {
      name: 'Team Green',
      color: '#10B981',
      formation: '2-3-1',
      players: [
        { memberProfileId: 'mem_saif', position: 'CM', pitchX: 50, pitchY: 50 },
      ]
    },
    teamB: {
      name: 'Team Blue',
      color: '#3B82F6',
      formation: '2-3-1',
      players: []
    }
  },
  {
    id: 'mat_past_derby',
    groupId: 'grp_blank_fc',
    title: 'Weekend Turf Derby',
    date: '2026-08-01',
    startTime: '20:00',
    endTime: '21:00',
    durationMinutes: 60,
    matchType: '7v7',
    maxPlayers: 14,
    minPlayers: 10,
    venueId: 'ven_bashundhara',
    venueName: 'Bashundhara Sports Arena',
    venueAddress: 'Block N, Bashundhara R/A, Dhaka',
    venueMapUrl: 'https://maps.google.com/?q=Bashundhara+Sports+Arena+Dhaka',
    totalTurfFee: 2100,
    organizerContribution: 0,
    extraCost: 0,
    gkDiscount: 0,
    guestFee: 150,
    estimatedCostPerPlayer: 150,
    isCostFrozen: true,
    finalCostPerPlayer: 150,
    rsvpDeadline: '2026-08-01T17:00:00Z',
    visibility: 'private',
    joinPolicy: 'members_only',
    isDiscoverable: false,
    isOpenToGuests: true,
    isLocked: true,
    isCancelled: false,
    status: 'completed',
    rulesNote: 'High intensity match.',
    createdByMemberId: 'mem_saif',
    createdByName: 'Saif Ahmed',
    result: {
      teamAScore: 7,
      teamBScore: 5,
      completedAt: '2026-08-01T21:15:00Z',
      statsRecorded: true,
    },
    motmWinnerMemberId: 'mem_saif',
    createdAt: '2026-07-28T10:00:00Z'
  }
];

export const INITIAL_RSVPS: MatchRSVP[] = [
  { id: 'rsv_1', matchId: 'mat_friday_clash', userId: 'usr_saif', memberProfileId: 'mem_saif', status: 'going', preferredPosition: 'CM', updatedAt: new Date().toISOString(), history: [{ status: 'going', timestamp: new Date().toISOString() }] }
];

export const INITIAL_JOIN_REQUESTS: MatchJoinRequest[] = [];

export const INITIAL_PAYMENTS: PaymentRecord[] = [
  { id: 'pay_1', matchId: 'mat_friday_clash', memberProfileId: 'mem_saif', amount: 150, status: 'paid', paymentMethod: 'bKash', datePaid: new Date().toISOString(), notes: 'Paid via bKash' }
];

export const INITIAL_COMMENTS: MatchComment[] = [
  { id: 'cmt_1', matchId: 'mat_friday_clash', memberProfileId: 'mem_saif', authorName: 'Saif', authorAvatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80', text: 'Welcome to GigaBalls FC! Registration is open for players to sign up.', timestamp: 'Just now', reactions: { '⚽': ['mem_saif'] } }
];

export const INITIAL_ANNOUNCEMENTS: Announcement[] = [
  { id: 'ann_1', groupId: 'grp_blank_fc', title: 'Friday Match Pitch & Time Confirmed', content: 'Turf booked at Bashundhara Sports Arena from 9 PM - 10 PM. Please register and RSVP early!', authorName: 'Saif', authorRole: 'Organizer', timestamp: 'Just now', isPinned: true }
];

export const INITIAL_POLLS: Poll[] = [
  {
    id: 'pol_1',
    groupId: 'grp_blank_fc',
    question: 'Which day works best for next week match?',
    options: [
      { id: 'opt_1', text: 'Friday 9 PM', voterMemberIds: ['mem_saif'] },
      { id: 'opt_2', text: 'Saturday 8 PM', voterMemberIds: [] },
    ],
    createdByMemberId: 'mem_saif',
    createdByName: 'Saif',
    createdAt: new Date().toISOString(),
    isClosed: false
  }
];

export const INITIAL_ACTIVITY_LOGS: ActivityLog[] = [
  { id: 'act_1', groupId: 'grp_blank_fc', actorName: 'Saif', action: 'Created Match', details: 'Created Friday Night Turf Clash at Bashundhara Sports Arena', timestamp: 'Just now' }
];

export const INITIAL_NOTIFICATIONS_SETTINGS: NotificationSettings = {
  newMatchCreated: true,
  matchInvitation: true,
  rsvpReminder: true,
  matchStartingSoon: true,
  teamAnnounced: true,
  teamChanged: true,
  venueChanged: true,
  matchCancelled: true,
  paymentReminder: true,
  pollCreated: true,
  resultPosted: true,
  motmVoting: true,
  groupAnnouncements: true,
  worldFootballScores: true,
  footballNews: true,
  inApp: true,
  push: true,
  email: false,
};

export const INITIAL_PRIVACY_SETTINGS: PrivacySettings = {
  phoneNumber: 'organizers_only',
  email: 'organizers_only',
  paymentHistory: 'organizers_only',
  balance: 'organizers_only',
  attendance: 'everyone',
  ratings: 'everyone',
  footballStats: 'everyone',
  profileInfo: 'everyone',
};

export const INITIAL_WORLD_FIXTURES: WorldMatchFixture[] = [
  { id: 'wf_1', league: 'UEFA Champions League', homeTeam: 'FC Barcelona', homeLogo: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=100&auto=format&fit=crop&q=80', awayTeam: 'Bayern Munich', awayLogo: 'https://images.unsplash.com/photo-1518091043644-c1d4457512c6?w=100&auto=format&fit=crop&q=80', homeScore: 3, awayScore: 1, timeOrStatus: "78'", isLive: true, isFavorite: true },
  { id: 'wf_2', league: 'Premier League', homeTeam: 'Arsenal', homeLogo: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=100&auto=format&fit=crop&q=80', awayTeam: 'Manchester City', awayLogo: 'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=100&auto=format&fit=crop&q=80', homeScore: 2, awayScore: 2, timeOrStatus: 'FT', isLive: false, isFavorite: true },
  { id: 'wf_3', league: 'La Liga', homeTeam: 'Real Madrid', homeLogo: 'https://images.unsplash.com/photo-1459865264687-595d652de67e?w=100&auto=format&fit=crop&q=80', awayTeam: 'Atletico Madrid', awayLogo: 'https://images.unsplash.com/photo-1575361204480-aadea25e6e68?w=100&auto=format&fit=crop&q=80', timeOrStatus: 'Tonight 01:00 AM', isLive: false, isFavorite: false },
];

export const INITIAL_WORLD_NEWS: FootballNewsItem[] = [
  {
    id: 'news_1',
    title: 'Lamine Yamal dazzles with 2 goals and masterclass assist in Champions League',
    source: 'FotMob News',
    publishedTime: '2 hours ago',
    summary: 'The young sensation produced another unbelievable performance to send Barca through to the quarter finals.',
    imageUrl: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=600&auto=format&fit=crop&q=80',
    category: 'Champions League',
    articleUrl: '#'
  },
  {
    id: 'news_2',
    title: 'Tactical Revolution: How 7v7 turf football is growing worldwide',
    source: 'Football Tactics Daily',
    publishedTime: '5 hours ago',
    summary: 'Smaller pitches, quick touches, high intensity: why casual turf football is becoming the preferred recreational format.',
    imageUrl: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=600&auto=format&fit=crop&q=80',
    category: 'Analysis',
    articleUrl: '#'
  }
];
